import React from 'react';
import { CheckCircle } from 'lucide-react';

const ThankYou = () => {
  return (
    <div id="thank-you" className="pt-64 pb-20 px-6 text-center">
      <div className="max-w-2xl mx-auto">
        <div className="mb-8 flex justify-center">
          <div className="bg-blue-500/20 p-6 rounded-full">
            <CheckCircle className="w-16 h-16 text-blue-500" strokeWidth={3} />
          </div>
        </div>
        <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 tracking-tighter">
          Booking Confirmed.
        </h1>
        <p className="text-xl text-gray-400 mb-10 leading-relaxed">
          Check your email for the invitation link. Our team is excited to help you scale your systems.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="bg-blue-600 text-white px-10 py-4 rounded-xl font-bold glow-button"
        >
          ← Return Home
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
